(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/physical-tickets.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/physical-tickets.js');
"use strict";


const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const {
  PhysicalTicketsForm
} = svs.ticket_partner.physicalTickets.physicalTicketsForm;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  InformationPanels
} = svs.ticket_partner.sharedComponents.informationPanels;
const PhysicalTickets = _ref => {
  var _svs$ticket_partner$d;
  let {
    history
  } = _ref;
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement(PhysicalTicketsForm, {
    history: history
  }))), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.physicalTrissArticles
  }));
};
svs.ticket_partner.physicalTickets.PhysicalTickets = PhysicalTickets;

 })(window);